import { STATUSES } from './constants';

export const getLabel = statusId => {
  const item = STATUSES.find(({ status }) => status === statusId);
  return item ? item.label : '';
};
